"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _javascriptStyleHelpers = require("@uie/javascript-style-helpers");
var _theme = require("@vds/theme");
var _selects = require("@vds-core/selects");
var _typography = require("@vds/typography");
var _tooltips = require("@vds/tooltips");
function _calculateOnlightBorders(readOnly, error, disabled, keyboardFocused) {
  var borderColor;
  var bottomColor;
  if (disabled || readOnly) {
    borderColor = "#D8DADA";
    bottomColor = "#D8DADA";
  } else if (keyboardFocused) {
    borderColor = "#000000";
  } else if (error) {
    borderColor = "#ED7000";
    bottomColor = "#ED7000";
  } else {
    borderColor = "#D8DADA";
    bottomColor = "#000000";
  }
  return "".concat(borderColor, " ").concat(borderColor, " ").concat(bottomColor, " ").concat(borderColor);
}
function _calculateOnDarkBorders(readOnly, error, disabled, keyboardFocused) {
  var borderColor;
  var bottomColor;
  if (disabled || readOnly) {
    borderColor = "#333333";
    bottomColor = "#333333";
  } else if (keyboardFocused) {
    borderColor = "#FFFFFF";
    bottomColor = "#FFFFFF";
  } else if (error) {
    borderColor = "#ED7000";
    bottomColor = "#ED7000";
  } else {
    borderColor = "#333333";
    bottomColor = "#FFFFFF";
  }
  return "".concat(borderColor, " ").concat(borderColor, " ").concat(bottomColor, " ").concat(borderColor);
}
function _calculateBorderColor(surface, readOnly, error, disabled, keyboardFocused) {
  switch (surface) {
    case "dark":
      return _calculateOnDarkBorders(readOnly, error, disabled, keyboardFocused);
    case "light":
    default:
      return _calculateOnlightBorders(readOnly, error, disabled, keyboardFocused);
  }
}
function _calculateElementColor(disabled, surface) {
  var elementColor;
  if (surface === "dark" && disabled) {
    elementColor = "#333333";
  } else if (surface === "light" && disabled) {
    elementColor = "#000000";
  } else if (surface === "dark" && !disabled) {
    elementColor = "#ffffff";
  } else {
    elementColor = "#000000";
  }
  return elementColor;
}
function _calculateBackgroundColor(error, surface) {
  var backgroundColor;
  if (surface === "dark") {
    backgroundColor = "#000000";
  } else if (error && surface === "light") {
    backgroundColor = "#ffffff";
  } else if (error && surface === "dark") {
    backgroundColor = "#000000";
  } else {
    backgroundColor = "#ffffff";
  }
  return backgroundColor;
}
var propTypes = {
  required: _propTypes["default"].bool,
  /**
   * If true, the label will be displayed inside the dropdown container. Otherwise, the label will be above the dropdown container like a normal text input.
   */
  inlineLabel: _propTypes["default"].bool,
  /**
   * String, array or node containing the title of the TooltipDialog
   */
  tooltipTitle: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].node]),
  /**
   * String, array or node containing the body content of the TooltipDialog
   */
  tooltipContent: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].node]),
  /**
   * If provided, will contain the string for the helper text
   */
  helperText: _propTypes["default"].string,
  /**
   * Determines the placement of the helper text (right or bottom)
   */
  helperTextPlacement: _propTypes["default"].oneOf(["right", "bottom"]),
  /**
   * Component will render in Inverted state.
   */
  inverted: _propTypes["default"].bool,
  /**
   * Locks the input from user interaction
   */
  locked: _propTypes["default"].bool
};
var defaultProps = {
  required: true,
  helperTextPlacement: "bottom",
  inlineLabel: false,
  inverted: false,
  locked: false
};
var DropdownSelect = function DropdownSelect(props) {
  var required = props.required,
    inlineLabel = props.inlineLabel,
    helperText = props.helperText,
    helperTextPlacement = props.helperTextPlacement,
    tooltipTitle = props.tooltipTitle,
    tooltipContent = props.tooltipContent,
    inverted = props.inverted,
    locked = props.locked,
    readOnly = props.readOnly;

  // Have to extract the props from passed from core and re-apply to vds-one tooltip here
  var _renderTooltip = function _renderTooltip(tooltipCoreProps) {
    return /*#__PURE__*/_react["default"].createElement(_tooltips.Tooltip, (0, _extends2["default"])({}, tooltipCoreProps, {
      inverted: tooltipCoreProps.surface === "dark"
    }));
  };
  return /*#__PURE__*/_react["default"].createElement(_selects.DropdownSelect, (0, _extends2["default"])({}, props, {
    inlineLabel: inlineLabel,
    readOnly: readOnly || locked,
    overflowEllipsis: true,
    surface: inverted ? "dark" : "light",
    transparentBackground: false // Brand 3.0 only
    ,
    typescale: _typography.TypographyConfig.getTypescale(),
    minWidth: inlineLabel ? "110px" : "66px",
    maxWidth: "596px",
    height: (0, _javascriptStyleHelpers.calculateRem)(44),
    selectPadding: (0, _javascriptStyleHelpers.calculateRem)(12, 44, 12, 12),
    labelMarginBottom: (0, _theme.calculateSpacing)("1X"),
    errorLabelSpacing: (0, _theme.calculateSpacing)("2X"),
    required: required,
    helperText: helperText,
    helperTextPlacement: helperTextPlacement,
    Tooltip: _renderTooltip,
    tooltipTitle: tooltipTitle,
    tooltipContent: tooltipContent,
    heavyErrorBorder: true,
    Body: _typography.Body,
    Micro: _typography.Micro,
    calculateBorderColor: _calculateBorderColor,
    calculateBackgroundColor: _calculateBackgroundColor,
    calculateElementColor: _calculateElementColor,
    borderRadius: "0",
    focusRing: false
  }));
};
DropdownSelect.propTypes = propTypes;
DropdownSelect.defaultProps = defaultProps;
var _default = exports["default"] = DropdownSelect;


//////////////////
// WEBPACK FOOTER
// ./~/@vds/selects/dist/cjs/components/DropdownSelect.js
// module id = 1566
// module chunks = 0